import React, { Component } from 'react';
import Prismic from 'prismic-javascript';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { estados } from '../../assets/cidades.json';

const Form = styled.form`
  .title {
    font: italic bold 40px 'Times new roman';
  }
  div {
    display: flex;
    margin-top: 30px;
    justify-content: space-between;
    position: relative;
    @media (max-width: 540px) {
      flex-wrap: wrap;
    }
    input {
      background: none;
      height: 60px;
      border: 0;
      border-bottom: 2px solid #979797;
      font: italic bold 20px 'Times new roman';
      width: 100%;
      color: #000;
      &[type='file'] {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        opacity: 0;
      }
    }
    select {
      background: none;
      height: 60px;
      border: 0;
      border-bottom: 2px solid #979797;
      font: italic bold 20px 'Times new roman';
      width: 100%;
      color: #000;
      &.half {
        width: 100%;
        @media (max-width: 540px) {
          &:last-child {
            margin-top: 30px;
          }
        }
        @media (min-width: 540px) {
          width: calc(50% - 15px);
        }
      }
    }
    textarea {
      font: italic bold 20px 'Times new roman';
      padding: 18px 26px;
      border: 2px solid #979797;
      background: none;
      height: 140px;
      width: 100%;
      box-sizing: border-box;
    }
    .select {
      position: absolute;
      background: #F1A857;
      font-size: 10px;
      color: #fff;
      padding: 0 12px;
      display: flex;
      border: 0;
      border-radius: 3px;
      right: 0;
      bottom: 13px;
      height: 34px;
      align-items: center;
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        background: #E59134;
      }
      i {
        width: 20px;
        height: 20px;
        margin-right: 10px;
        background: url(/images/streamline-icon-harddrive-upload@140x140@2x.png) no-repeat;
        background-size: cover;
      }
    }
    textarea::placeholder,
    input::placeholder {
      color: #000;
      opacity: 1;
    }
    button.submit {
      margin: 0 auto;
      cursor: pointer;
      max-width: 380px;
      width: 100%;
      background: #F1A857;
      display: flex;
      border-radius: 3px;
      border: 0;
      color: #fff;
      height: 60px;
      align-items: center;
      font-size: 16px;
      padding: 0;
      transition: all 0.3s;
      &:hover {
        background: #E59134;
        span {
          border-right: 1px solid #CD8226;
        }
      }
      @media (max-width: 1080px) {
        margin: 0 auto;
      }
      .text {
        height: 100%;
        flex-grow: 1;
        border-right: 1px solid #D99440;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .icon {
        display: flex;
        align-items: center;
        min-width: 82px;
        justify-content: center;
        i {
          width: 24px;
          background: url(/images/streamline-icon-send-email@140x140@2x.png) center no-repeat;
          height: 24px;
          background-size: contain;
        }
      }
    }
  }
`

class FormWorkWithUsPtBr extends Component {
  state = {
    depts: [],
    cidades: [],
    fileSelected: false,
  }
  componentDidMount = () => {
    const apiEndpoint = 'https://guararapes.cdn.prismic.io/api/v2'
    const Client = Prismic.client(apiEndpoint);
    const fetchData = async () => {
      const response = await Client.query(
        Prismic.Predicates.at('document.type', 'e-mails_formularios')
      )
      if (response.results[0]) {
        this.setState({depts: response.results[0].data.trabalhe_conosco});
      }
    }
    fetchData();
  }
  toggleEstado = (e) => {
    estados.map((item) => {
      if (item.sigla.toLowerCase() === e.target.value)
        this.setState({cidades: item.cidades});
      return true;
    });
  }
  render = () => {
    return (
      <Form>
        <strong className="title">Envie seu dados e currículo</strong>
        <div>
          <input type="text" name="nome" placeholder="Nome" />
        </div>
        <div>
          <select className="half" onChange={ this.toggleEstado } name="estado"> 
            <option value="estado">Estado</option> 
            <option value="ac">Acre</option> 
            <option value="al">Alagoas</option> 
            <option value="am">Amazonas</option> 
            <option value="ap">Amapá</option> 
            <option value="ba">Bahia</option> 
            <option value="ce">Ceará</option> 
            <option value="df">Distrito Federal</option> 
            <option value="es">Espírito Santo</option> 
            <option value="go">Goiás</option> 
            <option value="ma">Maranhão</option> 
            <option value="mt">Mato Grosso</option> 
            <option value="ms">Mato Grosso do Sul</option> 
            <option value="mg">Minas Gerais</option> 
            <option value="pa">Pará</option> 
            <option value="pb">Paraíba</option> 
            <option value="pr">Paraná</option> 
            <option value="pe">Pernambuco</option> 
            <option value="pi">Piauí</option> 
            <option value="rj">Rio de Janeiro</option> 
            <option value="rn">Rio Grande do Norte</option> 
            <option value="ro">Rondônia</option> 
            <option value="rs">Rio Grande do Sul</option> 
            <option value="rr">Roraima</option> 
            <option value="sc">Santa Catarina</option> 
            <option value="se">Sergipe</option> 
            <option value="sp">São Paulo</option> 
            <option value="to">Tocantins</option> 
          </select>
          <select className="half">
            <option>Cidade</option>
            {
              this.state.cidades && this.state.cidades.map((item, index) => {
                return (
                  <option value={ item} key={ index }>{ item }</option>
                )
              })
            }
          </select>
        </div>
        <div>
          <input type="email" name="nome" placeholder="Email" />
        </div>
        <div>
          <input type="tel" name="nome" placeholder="Telefone (com DDD)" />
        </div>
        <div>
          <select>
            <option>Selecione a Unidade Fabril</option>
            {
              this.state.depts.map((item, index) => {
                return (
                  <option key={ index } value={ item.email }>{ item.departamento }</option>
                )
              })
            }
          </select>
        </div>
        <div>
          { this.state.fileSelected && ( <input type="text" name="nome" placeholder="Curriculo selecionado" /> ) }
          { !this.state.fileSelected && ( <input type="text" name="nome" placeholder="Selecione seu currículo" /> ) }
          <button className="select">
            <i></i>
            <span>Selecione seu arquivo</span>
          </button>
          <input onChange={ (e) => { this.setState({fileSelected: !this.state.fileSelected})} } type="file" />
        </div>
        <div>
          <textarea placeholder="Mensagem"></textarea>
        </div>
        <div>
          <button className="submit">
            <span className="text">Enviar mensagem</span>
            <span className="icon">
              <i></i>
            </span>
          </button>
        </div>
      </Form>
    );
  }
}

FormWorkWithUsPtBr.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

export default FormWorkWithUsPtBr;
